module.exports = __webpack_public_path__ + "static/media/fg-left-palm.a47de82b.svg";